import { cva, type VariantProps } from 'class-variance-authority';

export const tabTriggerVariants = cva(
  'inline-flex items-center gap-2.5 px-[1.5625rem] py-[0.9375rem] rounded-[0.9375rem] overflow-hidden font-medium text-base text-center tracking-[0] leading-normal whitespace-nowrap h-auto',
  {
    variants: {
      variant: {
        default:
          'bg-accent text-foreground data-[state=active]:bg-primary data-[state=active]:text-white',

        outline:
          'text-black rounded-[0rem] bg-white data-[state=active]:text-black  data-[state=active]:border-border data-[state=active]:bg-white  data-[state=active]:font-bold px-[0.9375rem] pb-2.5 overflow-visible',
      },

      size: {
        big: 'text-base md:text-lg xl:text-xl data-[state=active]:border-b-[4px] data-[state=active]:border-[#725AC1]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type TabTriggerVariantsProps = VariantProps<typeof tabTriggerVariants>;
